import { Component, OnInit } from '@angular/core';
import { InventoryModel } from '@model/inventory-model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryModelService } from '@service/inventory-model/inventory-model.service';
import { InventoryModelAddComponent } from '../inventory-model-add/inventory-model-add.component';

@Component({
  selector: 'app-inventory-model-show',
  templateUrl: './inventory-model-show.component.html',
  styleUrls: ['./inventory-model-show.component.scss']
})
export class InventoryModelShowComponent implements OnInit {
  title: string = ""
  model: InventoryModel

  constructor(
    public modale: NgbActiveModal,
    private modalService: NgbModal,
    private modelService: InventoryModelService
  ) {
    this.model = this.modelService.getInventoryModel()
    this.title = "Détails du model d\'etat des lieux "+ this.model?.type?.libelle
  }

  ngOnInit() {
  }

  edit(data) {
    this.modelService.setInventoryModel(data)
    this.modelService.edit = true
    this.modal(InventoryModelAddComponent, 'modal-basic-title', 'lg', true, 'static')
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
}
